import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: 'Your data is protected with 256-bit SSL encryption'
    },
    {
      icon: 'Lock',
      title: 'GDPR Compliant',
      description: 'We follow strict data privacy regulations'
    },
    {
      icon: 'Eye',
      title: 'Privacy Protected',
      description: 'Your information is never shared with third parties'
    }
  ];

  return (
    <div className="mt-8 space-y-4">
      <div className="text-center">
        <h3 className="text-sm font-medium text-foreground mb-3">Enterprise Security</h3>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3 p-3 bg-card/50 rounded-md border border-border/30">
            <div className="flex-shrink-0 w-8 h-8 bg-success/10 rounded-full flex items-center justify-center">
              <Icon name={feature?.icon} size={14} className="text-success" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-foreground">{feature?.title}</p>
              <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="flex items-center justify-center space-x-4 pt-4 border-t border-border/30">
        <div className="flex items-center space-x-2">
          <div className="w-2 h-2 bg-success rounded-full"></div>
          <span className="text-xs text-muted-foreground">Secure Connection</span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="CheckCircle" size={12} className="text-success" />
          <span className="text-xs text-muted-foreground">Verified Platform</span>
        </div>
      </div>
    </div>
  );
};

export default SecurityIndicators;